module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-navy-4-4d838cccd5bad639c75f343499ea3749.webp";